import React from "react"
import Contact from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"
import Hero from "../../../components/web-app/hero"
import Layout from "../../../components/shared/layout"
import SEO from "../../../components/shared/seo"
import AdditionalFeatures from "../../../components/web-app/additional-features"
import FeatureHighlights from "../../../components/web-app/feature-highlights"
import SeeItInAction from "../../../components/web-app/see-it-in-action"

export default function WebAppPage({ location }) {
  return (
    <Layout location={location}>
      <SEO
        title="Embeddable Indoor Maps for Any Web Experience"
        description="Pre-built and easily embeddable indoor maps for any web experience. Responsive to both desktop and mobile and continues to evolve as new features are added."
      />
      <Hero />
      <FeatureHighlights />
      <AdditionalFeatures />
      <SeeItInAction />
      <Contact />
      <Footer />
    </Layout>
  )
}
